
import Vue, { PropType } from 'vue';
import {
  CvGrid,
  CvRow,
  CvColumn,
  CvCheckbox,
  CvInlineLoading,
} from '@carbon/vue';
import CheckmarkFilled16 from '@carbon/icons-vue/es/checkmark--filled/16';
import CloseFilled16 from '@carbon/icons-vue/es/close--filled/16';
import WarningFilled16 from '@carbon/icons-vue/es/warning--filled/16';
import ZoomArea24 from '@carbon/icons-vue/es/zoom--area/24';
import AddAlt24 from '@carbon/icons-vue/es/add--alt/24';
import SubtractAlt24 from '@carbon/icons-vue/es/subtract--alt/24';
import {
  removeMagnify,
  magnify,
} from '@/components/SmallDetails/utils/magnify';
import { SmallDetailsPayload } from '@/typings';
import { base64StringToBlob } from 'blob-util';

export default Vue.extend({
  name: 'SmallDetailsLogoOnly',
  components: {
    CvGrid,
    CvColumn,
    CvRow,
    CheckmarkFilled16,
    WarningFilled16,
    CloseFilled16,
    CvCheckbox,
    ZoomArea24,
    AddAlt24,
    SubtractAlt24,
    CvInlineLoading,
  },
  props: {
    uploadedFileName: {
      type: String,
      required: false,
      default: '',
    },
    uploadedFile: {
      type: String,
      required: false,
      default: '',
    },
    smallDetailsResult: {
      type: Object as PropType<SmallDetailsPayload>,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      isZoomEnabled: false,
      zoomSize: 2,
    };
  },

  computed: {
    imageUrl(): string {
      return this.smallDetailsResult.status !== 'NoCheck'
        ? URL.createObjectURL(this.smallDetailsResult.pngFileBlob)
        : URL.createObjectURL(base64StringToBlob(this.uploadedFile));
    },
  },

  watch: {
    zoomSize() {
      removeMagnify('w2p-flow-starter');
      magnify('myimage', this.zoomSize, 'w2p-flow-starter');
    },
  },

  methods: {
    onAcceptLogo(checked: boolean) {
      const value = checked ? new Date().toISOString() : undefined;
      this.smallDetailsResult.approvedAt = value;
    },

    enableZoom() {
      const subtarget = document.querySelector('w2p-flow-starter');
      const element =
        subtarget && subtarget.shadowRoot
          ? subtarget.shadowRoot.getElementById('magnifier-glass')
          : document.getElementById('magnifier-glass');
      if (element) {
        this.isZoomEnabled = false;
        this.zoomSize = 2;
        removeMagnify('w2p-flow-starter');
      } else {
        this.isZoomEnabled = true;
        magnify('myimage', this.zoomSize, 'w2p-flow-starter');
      }
    },
  },
});
